(function () {
  if (window.kkCartUpsellBound) return;
  window.kkCartUpsellBound = true;

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-kk-upsell-add]');
    if (!button) return;
    event.preventDefault();

    var wrap = button.closest('[data-kk-upsell]');
    var input = wrap && wrap.querySelector('[data-kk-upsell-variant]');
    var errorEl = wrap && wrap.querySelector('[data-kk-upsell-error]');
    if (!input || !input.value) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var drawer = document.querySelector('cart-drawer');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (errorEl) errorEl.textContent = '';

    try {
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(input.value),
              quantity: 1,
              properties: { _source: 'cart-upsell-' + (button.dataset.kkUpsellKind || 'item') },
            },
          ],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });
      var data = await response.json();

      if (data.status) {
        if (errorEl) errorEl.textContent = data.description || data.message || 'Could not add this item.';
        button.disabled = false;
        button.removeAttribute('aria-busy');
        return;
      }

      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kk-cart-upsell', cartData: data });
      }
    } catch (e) {
      if (errorEl) errorEl.textContent = 'Could not add this item. Please try again.';
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
